<template>
  <div class="overview" :class="{ mobileOfRoutingStatus: !isExtraLargeScreen }">
    <h6>Overview of inconsistencies</h6>
    <div class="card overview-card">
      <div class="card-header">
        <div class="card-header__title">Total inconsistencies found</div>
        <div class="card-header__amount">
          {{ totalMismatchNumber }}
        </div>
      </div>
      <div class="card-body">
        <p class="card-text">
          Status of ROAs and route objects as seen in BGP:
        </p>
        <div class="wrapper">
          <div class="item">
            <MismatchCard
              title="ROA mismatches"
              :mismatchList="roaMismatchListOfSelectedContext"
            ></MismatchCard>
          </div>
          <div class="item">
            <MismatchCard
              title="Route object mismatches"
              :mismatchList="routeObjectMismatchListOfSelectedContext"
            ></MismatchCard>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MismatchCard from './MismatchCard.vue';

export default {
  name: 'Overview',
  components: {
    MismatchCard
  },
  computed: {
    ...mapGetters('routingStatusStore', [
      'roaMismatchListOfSelectedContext',
      'routeObjectMismatchListOfSelectedContext'
    ]),
    ...mapGetters(['isExtraLargeScreen']),

    totalMismatchNumber() {
      return (
        this.roaMismatchListOfSelectedContext.length +
        this.routeObjectMismatchListOfSelectedContext.length
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.overview {
  margin-top: 2rem;

  h6 {
    font-size: 1.5rem;
    font-weight: 600;
  }

  .overview-card {
    background-color: transparent;
    margin-bottom: 2rem;
  }

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__title {
      font-size: 1.2rem;
      font-weight: 600;
    }

    &__amount {
      font-size: 2.5rem;
      //   font-weight: 600;
    }
  }

  .card-body {
    padding-bottom: 0;

    .wrapper {
      display: flex;
      justify-content: space-between;
    }
    .item {
      flex: 1;

      &:nth-child(1) {
        margin-right: 1rem;
      }
    }
  }
}

.mobileOfRoutingStatus {
  h6 {
    font-size: 1.25rem;
    font-weight: 600;
  }

  .overview {
    .card-body {
      .wrapper {
        flex-direction: column;
      }
      .item {
        &:nth-child(1) {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
